import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.backgroundColor};
    box-shadow: 0px 8px 20px #0000000f;
    border-radius: 24px;

    width: 288px;

    img {
      width: 288px;
      height: 168px;
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      object-fit: cover;
    }
  `}
`;

export const Content = styled.div`
  padding: 24px;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: 16px;
    font-weight: 600;

    line-height: 24px;
    color: ${theme.colors.colorGray500};
  `}
`;

export const Subtitle = styled.h3`
  margin-top: 16px;

  ${({ theme }) => css`
    font-size: 14px;
    font-weight: 500;

    line-height: 22px;
    color: ${theme.colors.colorGray400};
  `};
`;

export const ButtonWrapper = styled.div`
  margin-top: 24px;

  .details-btn {
    height: 40px;
    font-size: 16px;
    line-height: 24px;
  }
`;
